<app-loading-spinner *ngIf="loading; else not_loading"></app-loading-spinner>
<ng-template #not_loading>

  <table class="table" *ngIf="orgs && orgs.length; else no_orgs">
    <thead>
      <th>Name</th>
      <th>Org Code</th>
      <th *ngIf="showType">Type</th>
      <th *ngIf="showParent; else no_parent_head">Parent</th>
      <ng-template #no_parent_head>
        <th><span ngbTooltip="Suborganization count"><i class="fas fa-sitemap"></i></span></th>
        <th><span ngbTooltip="Class count"><i class="fas fa-graduation-cap"></i></span></th>
        <th><span ngbTooltip="Student count"><i class="fas fa-user"></i></span></th>
      </ng-template>
      <!-- <th></th> -->
    </thead>
    <tbody>
      <tr *ngFor="let org of orgs" class="hover" (click)="goToOrg(org, 'Classes')">
        <td>
          <a [routerLink]="getOrgRouterLink(org)" [queryParams]="getOrgRouterQueryParams(org, 'Classes')">
            {{ org.Description }}
          </a>
        </td>
        <td>
          {{ org.LoginCode }}
        </td>
        <td *ngIf="showType">
          {{ getOrganizationType(org) }}
        </td>
        <td *ngIf="showParent; else no_parent_body">
          <a routerLink="{{ '/organizations/' + org.ParentOrganizationID }}">
            {{ org.ParentOrganizationDescription }}
          </a>
        </td>
        <ng-template #no_parent_body>
          <td>
            <span *ngIf="org.Stats">{{ org.Stats.TotalSubOrgCount }}</span>
            <span *ngIf="!org.Stats"><i class="fal fa-spinner fa-spin"></i></span>
          </td>
          <td>
            <span *ngIf="org.Stats">{{ org.Stats.TotalClassCount }}</span>
            <span *ngIf="!org.Stats"><i class="fal fa-spinner fa-spin"></i></span>
          </td>
          <td>
            <span *ngIf="org.Stats">{{ org.Stats.TotalStudentCount }}</span>
            <span *ngIf="!org.Stats"><i class="fal fa-spinner fa-spin"></i></span>
          </td>
        </ng-template>
      </tr>
    </tbody>
  </table>

  <ng-template #no_orgs>
    <p class="mt-4">
      <ng-container *ngIf="orgs && !orgs.length">
        No organizations found.
      </ng-container>
      <app-loading-spinner *ngIf="!orgs"></app-loading-spinner>
    </p>
  </ng-template>

</ng-template>